import { render, staticRenderFns } from "./MobileLayout.vue?vue&type=template&id=50074a8d&scoped=true"
import script from "./MobileLayout.vue?vue&type=script&lang=js"
export * from "./MobileLayout.vue?vue&type=script&lang=js"
import style0 from "./MobileLayout.vue?vue&type=style&index=0&id=50074a8d&prod&lang=scss"
import style1 from "./MobileLayout.vue?vue&type=style&index=1&id=50074a8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50074a8d",
  null
  
)

export default component.exports